<template>
	<div>
		<div class="form-row">
		    <div class="form-group col-md-6">
		        <label>Nome *</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-model="dados.nome" 
		        	:id="name+'nome'" 
		        	@input="clearValidation('nome')">
		        <div class="invalid-feedback" :id="name+'nome-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-3">
		        <label>C.P.F.</label>
		        <input 
		        	type="text" 
		        	v-mask="'###.###.###-##'"
		        	class="form-control" 
		        	v-model="dados.cpf" 
		        	:id="name+'cpf'" 
		        	@input="clearValidation('cpf')">
		        <div class="invalid-feedback" :id="name+'cpf-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-3">
		        <label>Data de nascimento</label>
		        <input 
		        	type="date" 
		        	class="form-control" 
		        	v-model="dados.data_nascimento" 
		        	:id="name+'data_nascimento'" 
		        	@input="clearValidation('data_nascimento')">
		        <div class="invalid-feedback" :id="name+'data_nascimento-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-2">
		        <label>C.E.P.</label>
		        <input 
		        	type="text" 
		        	v-mask="'#####-###'"
		        	class="form-control" 
		        	v-model="dados.cep" 
		        	:id="name+'cep'" 
		        	@input="searchCep('cep')">
		        <div class="invalid-feedback" :id="name+'cep-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-4">
		        <label>Bairro</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-model="dados.bairro" 
		        	:id="name+'bairro'" 
		        	@input="clearValidation('bairro')">
		        <div class="invalid-feedback" :id="name+'bairro-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-3">
		        <label>Cidade</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-model="dados.cidade" 
		        	:id="name+'cidade'" 
		        	@input="clearValidation('cidade')">
		        <div class="invalid-feedback" :id="name+'cidade-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-3">
		        <label>Estado</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-mask="'AA'"
		        	v-model="dados.estado" 
		        	:id="name+'estado'" 
		        	@input="clearValidation('estado')">
		        <div class="invalid-feedback" :id="name+'estado-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Logradouro</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-model="dados.logradouro" 
		        	:id="name+'logradouro'" 
		        	@input="clearValidation('logradouro')">
		        <div class="invalid-feedback" :id="name+'logradouro-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Complemento</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-model="dados.complemento" 
		        	:id="name+'complemento'" 
		        	@input="clearValidation('complemento')">
		        <div class="invalid-feedback" :id="name+'complemento-invalid-feedback'"></div>
		    </div>
		</div>
	</div>
</template>



<script>
	export default {
		props: ['dados', 'name', 'errors'],
		data(){
			return {
				elementos: Object.keys(this.dados)
			}
		},
		methods : {
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			},
			searchCep(element){
				if(this.dados.cep.length == 9){
					axios.get('http://viacep.com.br/ws/'+this.dados.cep+'/json')
		            .then(response => {
		            	this.dados.bairro = response.data.bairro
		            	this.dados.cidade = response.data.localidade
		            	this.dados.estado = response.data.uf
		            	this.dados.logradouro = response.data.logradouro
		            })
		            .catch(error => {
		            	console.log(error)
		            });
		        }
		        this.clearValidation(element);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>